import React from "react";
import moment from 'moment';

export const DateColumnFormatter = (cellContent, row, rowIndex, dIndexName) => (
   //console.log(dIndexName, 'dIndexName',row.createdAt)
   !row.createdAt ?
    !row.joinDate ? 
       moment('2023-01-01T00:00:00.199Z').format('lll') 
         : moment(row.joinDate).format('lll') 
       : moment(row.createdAt).format('lll')
);
export const PayloadFormatter = (cellContent, row, rowIndex, dIndexName) => {
   return JSON.stringify(cellContent);
};
